import { DocCommands, SrvCommands, UICommands } from '../../gen-src/preslayer/CommandIds';
import { ExtensionPermission } from '../../gen-src/preslayer/Enums';

export type CommandId = DocCommands | UICommands | SrvCommands;
export class CommandPermissionMappingRegistry {
  private _permissionMap: { [commandId: string]: ExtensionPermission };

  public constructor() {
    this._permissionMap = {};
  }

  public addCommandPermission(commandId: CommandId, permission: ExtensionPermission): void {
    if (this._permissionMap[commandId]) {
      throw new Error('Only One Permission Per Command');
    }
    this._permissionMap[commandId] = permission;
  }

  public getCommandPermission(commandId: CommandId): ExtensionPermission | undefined {
    return this._permissionMap[commandId];
  }
}

export class CommandPermissionMappingRegistryFactory {
  public static createCmdPermissionMappingRegistry(): CommandPermissionMappingRegistry {
    const registry: CommandPermissionMappingRegistry = new CommandPermissionMappingRegistry();
    registry.addCommandPermission(DocCommands.GetConnectionDescriptionSummaryPresModels, ExtensionPermission.FullData);
    registry.addCommandPermission(DocCommands.GetActiveTables, ExtensionPermission.FullData);
    registry.addCommandPermission(DocCommands.ApiGetDatasourceLogicalTableIds, ExtensionPermission.FullData);
    registry.addCommandPermission(DocCommands.ApiGetDatasourceLogicalTableData, ExtensionPermission.FullData);
    registry.addCommandPermission(DocCommands.ApiGetWorksheetLogicalTableIds, ExtensionPermission.FullData);
    registry.addCommandPermission(DocCommands.ApiGetWorksheetUnderlyingLogicalTableData, ExtensionPermission.FullData);
    return registry;
  }
}
